import { t } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from 'designSystem/components/DropdownMenu'
import { OutlineScrollBox } from 'features/knowledgeDocumentViewer/components/toolbar/pdfDownloadMenuOptions.styles'
import type { PdfOutlineUnit } from 'features/knowledgeDocumentViewer/utils/pdfOutlineUnits'

type OutlineUnitListProps = {
  label: string
  kind: 'powerpoint' | 'spreadsheet'
  units: PdfOutlineUnit[]
  pdfSignedUrl: string | undefined
  isDownloading: boolean
  onOutlineUnit: (unit: PdfOutlineUnit) => void
}

function formatOutlineUnitLabel(
  unit: PdfOutlineUnit,
  kind: 'powerpoint' | 'spreadsheet'
): string {
  const { title, startPage, endPage } = unit
  if (kind === 'spreadsheet') {
    if (startPage === endPage) {
      return t`${title} — page ${startPage}`
    }
    return t`${title} — pages ${startPage}–${endPage}`
  }
  return title || t`Slide ${startPage}`
}

export function OutlineUnitList({
  label,
  kind,
  units,
  pdfSignedUrl,
  isDownloading,
  onOutlineUnit,
}: OutlineUnitListProps) {
  useLingui()
  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuLabel>{label}</DropdownMenuLabel>
      <OutlineScrollBox overflow='yAuto'>
        {units.map((unit) => (
          <DropdownMenuItem
            key={`${unit.startPage}-${unit.title}`}
            onSelect={() => onOutlineUnit(unit)}
            disabled={!pdfSignedUrl || isDownloading}>
            {formatOutlineUnitLabel(unit, kind)}
          </DropdownMenuItem>
        ))}
      </OutlineScrollBox>
    </>
  )
}
